import { useConfirm } from "material-ui-confirm";
import { useEffect, useState } from "react";
// @ts-ignore
import { MUIEditorState } from "react-mui-draft-wysiwyg";
import { useHistory, useParams } from "react-router";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import LabelsContext from "../../../lang/LabelsContext";
import MessageType from "../../../utils/MessageType";
import {
  getTypeFromNameFile,
  handleErrorMessage,
  renameFile,
  richTextStateFromHTML,
  richTextStateToHtml,
  uniqueBy,
  useEffectOnce,
} from "../../../utils/Utils";
import EnumDesignation from "../../../utils/enum/EnumDesignation";
import EnumGroup from "../../../utils/enum/EnumGroup";

const EXCLUDE_FILES = [
  EnumDesignation.TABLES,
  EnumDesignation.FIGURE_PDF,
  EnumDesignation.FIGURE,
  EnumDesignation.SUPPLEMENTARY_FIGURE,
  EnumDesignation.POWERPOINTER_PRESENTATION,
  EnumDesignation.ADDITIONAL_FILE,
  EnumDesignation.VIDEO_FILE,
];

const FILES_FILTER = [
  EnumDesignation.MANUSCRIPT,
  EnumDesignation.MARKED_MANUSCRIPTS,
  EnumDesignation.MARKED_MANUSCRIPTS_PDF,
  EnumDesignation.UNMARKED_MANUSCRIPT,
  EnumDesignation.LETTER_OF_REBUTAL,
  EnumDesignation.LETTER_OF_REBUTAL_PDF,
  EnumDesignation.FIGURE_PDF,
  EnumDesignation.FULL_ARTICLE,
  EnumDesignation.TABLES,
  EnumDesignation.ADDITIONAL_FILE,
  EnumDesignation.VIDEO_FILE,
  EnumDesignation.FIGURE,
];

export const FILTER_REVISION_VALUES = [
  {
    id: -2,
    name: "All",
  },
  {
    id: -1,
    name: "Active",
  },
];

export const FILTER_ALL = "all";
export const FILTER_LAST = "last";

interface CheckManuscriptServiceType {
  article: any;
  tabSelected: any;
  handleChangeTab: any;
  openNoteDialog: boolean;
  openNoteDialogAction: any;
  closeNoteDialogAction: any;
  note: any;
  setNote: any;
  saveNote: any;
  correction: any;
  setCorrection: any;
  correctionSubjectList: any;
  saveCorrection: any;
  openFileDialog: any;
  openFileDialogAction: any;
  closeFileDialogAction: any;
  designationOptions: any;
  uploadFile: any;
  filesList: any;
  setFilesList: any;
  handleResetDialog: any;
  files: any;
  accept: any;
  reject: any;
  uploading: boolean;
  validationPaperFiles: any;
  setValidationPaperFiles: any;
  filesByAssistant: any;
  authData: any;
  openRejectMail: () => void;
  openDialog: boolean;
  mailSuggestion: any;
  handleCloseDialog: () => void;
  deleteFile: (fileId: any) => void;
  revisionSelectedOptionAssistent: any;
  setRevisionSelectedOptionAssistent: any;
  updateAssitentFiles: (filesNew: any, value: string) => any;
  selectedDesignation: any;
  openDialogRegenratePdf: () => void;
}

export default function CheckManuscriptService(): CheckManuscriptServiceType {
  const { Labels } = LabelsContext();
  const {
    axiosGetArticleById,
    axiosPostArticleAddNote,
    axiosPostArticleCorrection,
    axiosUploadFile,
    axiosPostAssistantDecide,
    axiosGetAssistantRejectMail,
    axiosGetAssistantGetCorrectionMailsList,
    axiosPostDeleteFile,
    axiosPostArticleRegenerateCombinedPdf,
    axiosPostAddFile,
  }: ArticleControllerType = ArticleController();
  const { showMessage, authData } = useAppContext();
  const confirm = useConfirm();

  const [article, setArticle] = useState<any>([]);
  const [tabSelected, setTabSelected] = useState(0);
  const [openNoteDialog, setNoteDialog] = useState<boolean>(false);
  const [openFileDialog, setOpenFileDialog] = useState(false);
  const [note, setNote] = useState<string>(MUIEditorState.createEmpty());
  const [correction, setCorrection] = useState<any>({
    subject: undefined,
    details: MUIEditorState.createEmpty(),
  });
  const [files, setFiles] = useState<File[]>([]);
  const [filesByAssistant, setFilesByAssistant] = useState<any>();
  const [filesList, setFilesList] = useState<any>([]);
  const [uploading, setUploading] = useState<boolean>(false);
  const [mailSuggestion, setMailSuggestion] = useState<any>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [correctionMails, setCorrectionMails] = useState<any>([]);
  const [selectedDesignation, setSelectedDesignation] = useState<any>();
  const [selectedFile, setSelectedFile] = useState<any>();

  const [revisionSelectedOptionAssistent, setRevisionSelectedOptionAssistent] = useState<any>();

  const [validationPaperFiles, setValidationPaperFiles] = useState<any>([
    {
      id: 1,
      name: "Check if the manuscript has followed the guidelines",
      checked: false,
    },
  ]);

  const { id }: any = useParams();

  const history = useHistory();

  const correctionSubjectList = [
    { name: "Manuscript does not follow template", id: "doesNotFollow" },
    { name: "Figures are incorrect", id: "figuresIncorrect" },
    { name: "Files are missing / failed to upload", id: "filesMissing" },
  ];

  const designationOptions: any = [
    { name: "Manuscript", code: EnumDesignation.MANUSCRIPT },
    { name: "Full manuscript", code: EnumDesignation.FULL_MANUSCRIPT },
    { name: "Figure", code: EnumDesignation.FIGURE },
    { name: "FigurePDF", code: EnumDesignation.FIGURE_PDF },
    { name: "Tables", code: EnumDesignation.TABLES },
    { name: Labels.VIDEO_FILE, code: EnumDesignation.VIDEO_FILE },
    { name: "Letter of Rebuttal PDF", code: EnumDesignation.LETTER_OF_REBUTAL_PDF },
    { name: "Marked manuscript PDF", code: EnumDesignation.MARKED_MANUSCRIPTS_PDF },
    { name: "Unmarked Manuscript", code: EnumDesignation.UNMARKED_MANUSCRIPT },
    { name: Labels.ADDITIONAL_FILE, code: EnumDesignation.ADDITIONAL_FILE },
  ];

  const loadCorrectionMailList = () => {
    axiosGetAssistantGetCorrectionMailsList(id)
      .then((response: any) => setCorrectionMails(response.data))
      .catch((error: any) => handleErrorMessage(showMessage, error));
  };

  useEffect(() => {
    if (correction.subject) {
      const suggectionMail = correctionMails[correction.subject.id];
      setCorrection({
        ...correction,
        details: richTextStateFromHTML(suggectionMail.text),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correction.subject]);

  const groupedDataFiles = (data: any) =>
    data?.reduce((acc: any, obj: any) => {
      if (!acc[obj.name] || new Date(obj.uploadDate) > new Date(acc[obj.name].uploadDate)) {
        acc[obj.name] = obj;
      }
      return acc;
    }, {});

  const updateAssitentFiles = (filesNew: any, value: string) => {
    if (value === FILTER_LAST) {
      const filesFilterNew: any = [];
      const uniqueByType = uniqueBy(filesNew, "designation");
      uniqueByType.forEach((uniqType: any) => {
        if (EXCLUDE_FILES.includes(uniqType)) {
          filesFilterNew.push(...filesNew?.filter((f: any) => f.designation === uniqType));
        } else {
          const maxIdByType = Math.max(
            ...filesNew.filter((f: any) => f.designation === uniqType).map((o: any) => o.id)
          );
          const filedFindBy = filesNew?.find((f: any) => f.designation === uniqType && f.id === maxIdByType);
          filesFilterNew.push(filedFindBy);
        }
      });
      return filesFilterNew;
    }

    return filesNew;
  };

  const loadArticle = (isInit?: boolean) => {
    axiosGetArticleById(id)
      .then((result: any) => {
        setArticle(result.data);
        if (authData?.user?.group.group === EnumGroup.ASSISTANT) {
          const newFilesByAssistant: any = {};
          const filterByRevision: any = {};
          [...Array(result.data.revision + 1)].reverse().forEach((n: any, index: number) => {
            const arrayNew = result.data.files
              .filter((x: any) => x.revision === index && FILES_FILTER.includes(x.type))
              .map((f: any, i: any) => ({
                id: f.id,
                name: f.filename,
                designation: f.type,
                revision: f.revision,
                type: getTypeFromNameFile(f.filename),
                location: f.location,
                uploadDate: f.uploadDate,
              }));
            const filesSortFindDistinct = Object.values(groupedDataFiles(arrayNew));
            newFilesByAssistant[index] = filesSortFindDistinct.sort((a: any, b: any) => b.uploadDate - a.uploadDate);
            filterByRevision[index] = FILTER_LAST;
          });
          if (isInit) {
            setRevisionSelectedOptionAssistent(filterByRevision);
          }
          setFilesByAssistant(newFilesByAssistant);
        } else {
          const arrayFile: any = [];
          result.data.files?.forEach((f: any, i: number) => {
            if (FILES_FILTER.includes(f.type)) {
              arrayFile.push({
                id: f.id,
                name: f.filename,
                revision: f.revision,
                designation: f.type,
                type: getTypeFromNameFile(f.filename),
                location: f.location,
                uploadDate: f.uploadDate,
              });
            }
          });
          const filesSortFindDistinct = Object.values(groupedDataFiles(arrayFile));
          setFilesList(filesSortFindDistinct);
        }
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  useEffectOnce(() => {
    loadCorrectionMailList();
    loadArticle(true);
  });

  const openNoteDialogAction = () => {
    setNoteDialog(true);
  };

  const closeNoteDialogAction = () => {
    setNoteDialog(false);
    setNote(MUIEditorState.createEmpty());
  };

  const openFileDialogAction = (id: number) => {
    if (id && authData?.user?.group.group === EnumGroup.ASSISTANT) {
      setSelectedDesignation(filesByAssistant[article.revision].find((d: any) => d.id === id));
    } else {
      setSelectedDesignation(null);
    }

    setSelectedFile(!isNaN(id) ? id : null);

    setOpenFileDialog(true);
  };

  const closeFileDialogAction = () => {
    setOpenFileDialog(false);
    setNote(MUIEditorState.createEmpty());
  };

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabSelected(newValue);
  };

  const openDialogRegenratePdf = () =>
    confirm({
      title: "Regenerate full article pdf",
      description: "New combined PDF file will be generated soon and will replace the old one. It may take a minute.",
      confirmationText: "OK",
      cancellationText: "Cancel",
      confirmationButtonProps: {
        variant: "contained",
        color: "primary",
      },
    })
      .then(() => axiosPostArticleRegenerateCombinedPdf(article.id))
      .catch(() => {});

  const deleteFile = (fileId: any) => {
    if (+fileId) {
      axiosPostDeleteFile(article.id, fileId)
        .then((response: any) => {
          loadArticle();
        })
        .catch((error: any) => handleErrorMessage(showMessage, error));
    } else {
      removeFileFromList(fileId);
    }
  };

  const removeFileFromList = (fileId: number) => {
    if (authData?.user?.group.group === EnumGroup.ASSISTANT) {
      const lastRevision = Object.keys(filesByAssistant);
      const fileByLastRevision = filesByAssistant[lastRevision[0]].filter((file: any) => file.id !== fileId);
      setFilesByAssistant({
        ...filesByAssistant,
        [lastRevision[0]]: fileByLastRevision,
      });
    } else {
      setFilesList(filesList.filter((file: any) => file.id !== fileId));
    }
  };

  const saveNote = () => {
    axiosPostArticleAddNote(id, richTextStateToHtml(note))
      .then((response: any) => {
        setArticle(response.data);
        closeNoteDialogAction();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const saveCorrection = () => {
    const text = richTextStateToHtml(correction.details);
    if (!correction.subject) {
      showMessage("Field manuscript is required.", MessageType.ERROR);
    } else if (!text) {
      showMessage("Field message of correction is required.", MessageType.ERROR);
    } else {
      const suggectionMail = correctionMails[correction.subject.id];

      const emailDto = {
        to: suggectionMail.to.length > 0 ? suggectionMail.to.join() : null,
        subject: suggectionMail.subject,
        text: text,
        from: authData?.user.email,
        replyTo: authData?.user.email,
        sentDate: new Date(),
      };

      axiosPostArticleCorrection(
        id,
        {
          reason: correction.subject.name,
        },
        emailDto
      )
        .then((response: any) => {
          setArticle(response.data);
          closeNoteDialogAction();
          history.push("/toDoList");
          showMessage(
            "The status of article has been changed to `Correction` and a message has been send to the author.",
            MessageType.SUCCESS
          );
        })
        .catch((error: any) => {
          handleErrorMessage(showMessage, error);
        });
    }
  };

  const uploadFile = (file: any, values: any) => {
    const type = getTypeFromNameFile(file[0].name);

    const newFile = renameFile(
      file[0],
      `${article.articleId}${values.designation.code}${filesList.length + 1}.${type}`
    );

    setUploading(true);
    axiosUploadFile(article.id, [newFile])
      .then((response: any) => {
        if (selectedFile) {
          axiosPostDeleteFile(article.id, selectedFile);
        }

        axiosPostAddFile(article.id, {
          filename: response.data.fileName,
          type: values.designation.code,
          fileType: getTypeFromNameFile(newFile.name),
          revision: Number(article.revision ?? 0),
        })
          .then((response: any) => {
            loadArticle();
            closeFileDialogAction();
            setUploading(false);
          })
          .catch((error: any) => handleErrorMessage(showMessage, error));
      })
      .catch((error: any) => {
        setUploading(false);
        handleErrorMessage(showMessage, error);
      });
  };

  const handleResetDialog = (disabled: boolean, setFieldValue: any, files: File[], size: any, type: any) => {
    if (files !== null) setFiles(files);
    setFieldValue("size", size);
    setFieldValue("type", type);
  };

  const accept = () => {
    axiosPostAssistantDecide(article.id, {
      accept: true,
      files: [],
    })
      .then((response: any) => {
        history.push("/assitantEditorList");
        showMessage("Article successfully accepted.", MessageType.SUCCESS);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const reject = (values: any) => {
    const emailDto = {
      to: values.mailto.length > 0 ? values.mailto.join() : null,
      subject: values.subject,
      text: richTextStateToHtml(values.message),
      from: authData?.user.email,
      replyTo: authData?.user.email,
      sentDate: new Date(),
    };

    axiosPostAssistantDecide(article.id, {
      accept: false,
      files: [],
      emailDto: emailDto,
    })
      .then((response: any) => {
        handleCloseDialog();
        history.push("/assitantEditorList");
        showMessage("Article successfully rejected.", MessageType.SUCCESS);
      })
      .catch((error: any) => handleErrorMessage(showMessage, error));
  };

  const openRejectMail = () => {
    axiosGetAssistantRejectMail(article.id)
      .then((result: any) => {
        setMailSuggestion(result.data);
        setOpenDialog(true);
      })
      .catch((error: any) => handleErrorMessage(showMessage, error));
  };

  const handleCloseDialog = () => {
    setMailSuggestion(null);
    setOpenDialog(false);
  };

  return {
    article,
    tabSelected,
    handleChangeTab,
    openNoteDialog,
    openNoteDialogAction,
    closeNoteDialogAction,
    note,
    setNote,
    saveNote,
    correction,
    setCorrection,
    correctionSubjectList,
    saveCorrection,
    openFileDialog,
    openFileDialogAction,
    closeFileDialogAction,
    designationOptions,
    uploadFile,
    filesList,
    setFilesList,
    handleResetDialog,
    files,
    accept,
    reject,
    uploading,
    validationPaperFiles,
    setValidationPaperFiles,
    filesByAssistant,
    authData,
    openRejectMail,
    openDialog,
    mailSuggestion,
    handleCloseDialog,
    deleteFile,
    revisionSelectedOptionAssistent,
    setRevisionSelectedOptionAssistent,
    updateAssitentFiles,
    selectedDesignation,
    openDialogRegenratePdf,
  };
}

export type { CheckManuscriptServiceType };
